import { render } from "./PenaltyZone.vue?vue&type=template&id=bae4c28e"
import script from "./PenaltyZone.vue?vue&type=script&lang=js"
export * from "./PenaltyZone.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__